import api from './api';
import {mapTimeEntriesDto} from "../dto/TimeEntrieDTO";

export const getTimeEntriesForUserConclusions = async ({userId}) => {
    try {
        console.log(`/timeentries/user_stats/${userId}`);
        const res = await api.get(`/timeentries/user_stats/${userId}`);
        return res.data;
    } catch (err) {
        console.error("Error loading time entries conclusion for user:", err);
        throw err;
    }
};

export const getTimeEntriesForUser = async ({userId}) => {
    try {
        const res = await api.get(`/timeentries/user/${userId}`);
        return mapTimeEntriesDto(res.data);
    } catch (err) {
        console.error("Error loading time entries for user:", err);
        throw err;
    }
};

export const updateTimeEntriesForUser = async ({updatedEntry}) => {
    try {
        await api.patch(`/timeentries/${updatedEntry.id}`, updatedEntry)
    } catch (err) {
        console.error("Error updating time entry:", err);
        throw err;
    }
};

export const deleteTimeEntries = async ({id}) => {
    try {
        const res = await api.delete(`/timeentries/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting time entries:", err);
        throw err;
    }
};

export const addTimeEntries = async (newEntry) => {
    try {
        const res = await api.post(`/timeentries`, newEntry);
        return res.data;
    } catch (err) {
        console.error("Error adding new time entries:", err);
        throw err;
    }
}